import ProfileCommentsBox, { Props } from './ProfileCommentsBox';
import ProfileCommentsContainer, {
  ConnectedPropKeys,
} from './ProfileComments.container';

export default ProfileCommentsContainer(
  ProfileCommentsBox
) as React.ComponentClass<Without<Props, ConnectedPropKeys>>;
